module.exports = __webpack_public_path__ + "img/menu1-it.a9ca636a.jpg";